import StepInstall from './src/step-install';

export default StepInstall;
